// React Imports
import * as React from 'react';

// Third Party Imports
import { I18n } from 'react-redux-i18n';

// Component Imports
import { Title } from '../../../title';
import { PedigreeSetting } from './pedigree-setting/pedigree-setting';
import { PedigreeSettingSelectedField } from './pedigree-setting/components/fields-management/fields-management.types';

// Type Imports
import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';
import { QuestionnaireFolderField } from '@modules/fhq-design-tool/types/field';
import { QuestionnaireUpdateLocalDto } from '@modules/fhq-design-tool/dto/questionnaire-update-local-dto';
import { QuestionnaireCreateLocalDto } from '@modules/fhq-design-tool/dto/questionnaire-create-local-dto';
import { QuestionnaireManagementErrors } from '@modules/fhq-design-tool/controllers/questionnaire-validation';

// Style Imports
import './rename-pedigree-on-submit.styles.scss';

// Other Imports

export type RenamePedigreeOnSubmitProps = {
  getFields: (params: { folderId?: number }) => Promise<QuestionnaireFolderField[]>;
  getFolders: () => Promise<FolderPrimaryListDto[]>;
  questionnaire: QuestionnaireUpdateLocalDto | QuestionnaireCreateLocalDto;
  onChange: (questionnaire: QuestionnaireUpdateLocalDto | QuestionnaireCreateLocalDto) => void;
  showErrorMessage: (message: string) => void;
  errors?: QuestionnaireManagementErrors;
};

export const RenamePedigreeOnSubmit: React.FC<RenamePedigreeOnSubmitProps> = (props) => {
  
  const { getFields, getFolders, onChange, questionnaire, errors } = props;

  const handleRenamePedigreeOnSubmitChange = React.useCallback((fields: PedigreeSettingSelectedField[]) => {

    const pednameFieldsData = fields.map((field, index) => {
      // Determine the systemfield value by checking all possible sources
      let systemFieldValue;
      
      // First check if systemfield is explicitly set on the field itself
      if (field.systemfield !== undefined) {
        systemFieldValue = field.systemfield;
      } 
      // Then check if it's in the nested field object with camelCase (systemField)
      else if (field.field?.systemField !== undefined) {
        systemFieldValue = field.field.systemField;
      }
      // Finally check if it's in the nested field object with lowercase (systemfield)
      else if (field.field?.systemField !== undefined) {
        systemFieldValue = field.field.systemField;
      }
      // Default to 0 if not found anywhere
      else {
        systemFieldValue = 0;
      }
      
      // Convert to 1/0 if it's boolean
      if (typeof systemFieldValue === 'boolean') {
        systemFieldValue = systemFieldValue ? 1 : 0;
      }
      
      return {
        order: index + 1,
        fieldId: field.fieldId,
        systemfield: systemFieldValue,
        tableId: 0,
        delimiter: field.delimiter,
        field: field.field,
        fieldName: field.fieldName,
      };
    });
    // @ts-ignore //To-do to remove this
    questionnaire.statusTab.pednameFields = pednameFieldsData;
    onChange(questionnaire);
  }, [onChange, questionnaire]);
  
  return (
    <div className="FhqDesignToolStatusActionsRenamePedigreeOnSubmit">
      <Title text={I18n.t('Rename Pedigree on Submit')} />
      <PedigreeSetting 
        clearable
        value={questionnaire.statusTab.pednameFields || []}
        labelWidth={100}
        onChange={handleRenamePedigreeOnSubmitChange}
        metadata={{
          description: 'rename-pedigree-on-submit-1',
        }}
        getFields={getFields}
        getFolders={getFolders}
        label={I18n.t('Field')}
        errors={errors}
      />

    </div>
  );
};